import epsClient from 'enrollment-platform/api/eps.client'
import type {
  ServiceAreaLevelHistoryQueryDto,
  PaginatedServiceAreaLevelHistoryResponseDto,
} from './dto/service-area-level-history.dto'
import type {
  BulkDeleteServiceAreaOverrideRulesRequestDto,
  BulkUpdateServiceAreaStatusByIdsRequestDto,
  CheckDuplicateServiceAreaOverrideRuleQueryDto,
  CheckDuplicateServiceAreaOverrideRuleResponseDto,
  CreatePlanServiceAreaOverrideRuleRequestDto,
  DeleteServiceAreaOverrideRulesByFilterRequestDto,
  DeleteServiceAreaOverrideRulesByFilterResponseDto,
  ListPlanServiceAreaOverrideRulesQueryDto,
  ListPlanServiceAreaOverrideRulesResponseDto,
  PlanServiceAreaOverrideRuleResponseDto,
  UpdateServiceAreaStatusByFilterBodyDto,
  UpdateServiceAreaStatusByFilterQueryDto,
  UpdateServiceAreaStatusByFilterResponseDto,
  UpdatePlanServiceAreaOverrideRuleRequestDto,
  UpdatePlanServiceAreaOverrideRuleStatusRequestDto,
} from './dto/plan-service-area-override-rules.dto'

export const SERVICE_AREA_OVERRIDE_RULE_BASE =
  '/api/v1/plan-service-area-override-rules'

export const listServiceAreaOverrideRules = async (
  params: ListPlanServiceAreaOverrideRulesQueryDto
): Promise<ListPlanServiceAreaOverrideRulesResponseDto> => {
  const { data } =
    await epsClient.get<ListPlanServiceAreaOverrideRulesResponseDto>(
      SERVICE_AREA_OVERRIDE_RULE_BASE,
      { params }
    )
  return data
}

export const getServiceAreaOverrideRule = async (
  id: string
): Promise<PlanServiceAreaOverrideRuleResponseDto> => {
  const { data } = await epsClient.get<PlanServiceAreaOverrideRuleResponseDto>(
    `${SERVICE_AREA_OVERRIDE_RULE_BASE}/${id}`
  )
  return data
}

export const createServiceAreaOverrideRule = async (
  body: CreatePlanServiceAreaOverrideRuleRequestDto
): Promise<PlanServiceAreaOverrideRuleResponseDto> => {
  const { data } = await epsClient.post<PlanServiceAreaOverrideRuleResponseDto>(
    SERVICE_AREA_OVERRIDE_RULE_BASE,
    body
  )
  return data
}

export const updateServiceAreaOverrideRule = async (
  id: string,
  body: UpdatePlanServiceAreaOverrideRuleRequestDto
): Promise<PlanServiceAreaOverrideRuleResponseDto> => {
  const { data } =
    await epsClient.patch<PlanServiceAreaOverrideRuleResponseDto>(
      `${SERVICE_AREA_OVERRIDE_RULE_BASE}/${id}`,
      body
    )
  return data
}

export const checkDuplicateServiceAreaOverrideRule = async (
  query: CheckDuplicateServiceAreaOverrideRuleQueryDto
): Promise<CheckDuplicateServiceAreaOverrideRuleResponseDto> => {
  const { data } =
    await epsClient.get<CheckDuplicateServiceAreaOverrideRuleResponseDto>(
      `${SERVICE_AREA_OVERRIDE_RULE_BASE}/check-duplicate`,
      { params: query }
    )
  return data
}

export const updateServiceAreaOverrideRuleStatus = async (
  id: string,
  body: UpdatePlanServiceAreaOverrideRuleStatusRequestDto
): Promise<PlanServiceAreaOverrideRuleResponseDto> => {
  const { data } =
    await epsClient.patch<PlanServiceAreaOverrideRuleResponseDto>(
      `${SERVICE_AREA_OVERRIDE_RULE_BASE}/${id}/status`,
      body
    )
  return data
}

export const deleteServiceAreaOverrideRule = async (
  id: string
): Promise<void> => {
  await epsClient.delete(`${SERVICE_AREA_OVERRIDE_RULE_BASE}/${id}`)
}

export const bulkDeleteServiceAreaOverrideRules = async (
  body: BulkDeleteServiceAreaOverrideRulesRequestDto
): Promise<void> => {
  await epsClient.delete(`${SERVICE_AREA_OVERRIDE_RULE_BASE}/bulk`, {
    data: body,
  })
}

export const deleteServiceAreaOverrideRulesByFilter = async (
  params: DeleteServiceAreaOverrideRulesByFilterRequestDto
): Promise<DeleteServiceAreaOverrideRulesByFilterResponseDto> => {
  const { data } = await epsClient.delete(SERVICE_AREA_OVERRIDE_RULE_BASE, {
    params,
  })
  return data as DeleteServiceAreaOverrideRulesByFilterResponseDto
}

export const bulkUpdateServiceAreaStatusByIds = async (
  body: BulkUpdateServiceAreaStatusByIdsRequestDto
): Promise<void> => {
  await epsClient.patch(`${SERVICE_AREA_OVERRIDE_RULE_BASE}/bulk/status`, body)
}

export const updateServiceAreaStatusByFilter = async (
  query: UpdateServiceAreaStatusByFilterQueryDto,
  body: UpdateServiceAreaStatusByFilterBodyDto
): Promise<UpdateServiceAreaStatusByFilterResponseDto> => {
  const { data } =
    await epsClient.patch<UpdateServiceAreaStatusByFilterResponseDto>(
      `${SERVICE_AREA_OVERRIDE_RULE_BASE}/status`,
      body,
      { params: query }
    )
  return data
}

export const listServiceAreaLevelHistory = async (
  params: ServiceAreaLevelHistoryQueryDto
): Promise<PaginatedServiceAreaLevelHistoryResponseDto> => {
  const { data } =
    await epsClient.get<PaginatedServiceAreaLevelHistoryResponseDto>(
      `${SERVICE_AREA_OVERRIDE_RULE_BASE}/history`,
      { params }
    )
  return data
}
